import React from 'react';
import PropTypes from 'prop-types';

/**
 * SkeletonProgressBar Component
 * 
 * A skeleton for loading progress bars and similar horizontal elements.
 * 
 * @param {Object} props
 * @param {string} props.height - Height variant: 'thin' | 'normal' | 'thick'
 * @param {string} props.width - Width class or custom width
 * @param {string} props.className - Additional CSS classes
 * @component
 */
export default function SkeletonProgressBar({ 
  height = 'normal', 
  width = 'w-full', 
  className = '' 
}) {
  const heightClasses = {
    thin: 'h-2',
    normal: 'h-4',
    thick: 'h-6'
  };

  return (
    <div
      className={`bg-gray-200 rounded-full animate-pulse ${heightClasses[height]} ${width} ${className}`}
      aria-label="Loading progress bar"
    />
  );
}

SkeletonProgressBar.propTypes = {
  height: PropTypes.oneOf(['thin', 'normal', 'thick']),
  width: PropTypes.string,  
  className: PropTypes.string,
};